import LicensesFilter from './LicensesFilter';

export default LicensesFilter;
